import { FC, useEffect } from "react";
import { useLocation } from "react-router";
import clsx from "clsx";
import { useLayout } from "../core";
import { DrawerComponent } from "../../assets/ts/components";
import { WithChildren } from "../../helpers";
import { isAssistimoRoute } from "app/modules/aiAssistant/shared/assistimoRoutes";

const Content: FC<WithChildren> = ({ children }) => {
  const { classes } = useLayout();
  const location = useLocation();
  useEffect(() => {
    DrawerComponent.hideAll();
  }, [location]);

  const isAssistimoPage = isAssistimoRoute(location.pathname);
  const isFullWidth = isAssistimoPage || location.pathname.toLowerCase() === "/dashboard";

  const baseClasses = isFullWidth ? "w-100" : classes.contentContainer.join(" ");
  const flexClasses = isAssistimoPage ? "d-flex flex-column px-4" : "";

  return (
    <div id="kt_content_container" className={clsx(baseClasses, flexClasses)}>
      {children}
    </div>
  );
};

export { Content };
